export default __webpack_public_path__ + "static/media/fish&chips-italic.10ebe6f1.woff2";